import React from 'react';
import { faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './ThumbsUpButton.module.css';
import { CommonButton } from '_components';


export class ThumbsUpButton extends React.Component {
    render() {
        let cls;
        cls = styles.button;

        if (this.props.className ) {
            cls += ' ' + this.props.className;
        }

        return (
            <CommonButton title={this.props.title ? this.props.title : 'Approve'} onClick={this.props.onClick} size={this.props.size} className={cls} >
                <FontAwesomeIcon icon={faThumbsUp} transform="shrink-6" color="white" />
            </CommonButton>
        );
    }
}
